import * as React from 'react'

import DrillDownFilter from '~/client/src/shared/components/DrillDownFilter'
import { FilterButton } from '~/client/src/shared/components/Filters/triggers'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { useResourceFieldContext } from '../ResourceFieldContext'

function DefaultFilter(): JSX.Element {
  const {
    filterSelection,
    filterCategories,
    activePopup,
    setFilterDefaults,
    closePopup,
    togglePopup,
  } = useResourceFieldContext()

  const isOpen = activePopup === 'filters'

  const handleOpenChange = React.useCallback(
    (open: boolean) => {
      if (!open) closePopup()
    },
    [closePopup],
  )

  const handleFilterApply = React.useCallback(
    (selectedIds: string[]) => {
      setFilterDefaults(selectedIds)
    },
    [setFilterDefaults],
  )

  const filterCount = filterSelection.length

  return (
    <DrillDownFilter.Popover
      open={isOpen}
      onOpenChange={handleOpenChange}
      side="right"
      trigger={
        <FilterButton
          onClick={() => togglePopup('filters')}
          label={Localization.translator.filters}
          badgeCount={filterCount > 0 ? filterCount : undefined}
        />
      }
    >
      <DrillDownFilter.Desktop
        title={Localization.translator.filterBy}
        categories={filterCategories}
        initialSelection={filterSelection}
        onApply={handleFilterApply}
      />
    </DrillDownFilter.Popover>
  )
}

export default DefaultFilter
